import { Injectable } from '@angular/core';
import { PermissionsService } from './permissions.service';
import { CompanyService } from './Company.service';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  constructor(
    private permissionsService: PermissionsService,
    private companyService: CompanyService
  ) { }

  init(): Promise<void> {
    // ── Rehydrate company context (cross-tab safe) ──────────────────────
    // Priority: sessionStorage (tab-scoped) > localStorage (shared seed)
    //
    // New tab  → sessionStorage is empty  → inherit from localStorage → copy to sessionStorage
    // Refresh  → sessionStorage has value → use it (ignores localStorage changes from other tabs)
    // Switch   → header.component updates BOTH sessionStorage + localStorage
    const tabGcId = sessionStorage.getItem('header_gc_id');
    const sharedGcId = localStorage.getItem('header_gc_id');

    const gcIdToUse = tabGcId ?? sharedGcId; // prefer tab-scoped value

    if (gcIdToUse) {
      this.companyService.setHeaderCompany(Number(gcIdToUse));
      // Persist to sessionStorage so refreshes within this tab are safe
      sessionStorage.setItem('header_gc_id', gcIdToUse);
    }

    // Delegate permission fetching to PermissionsService (single source of truth)
    return this.permissionsService.loadPermissions();
  }
}